import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['container', 'primaryRegion', 'secondaryRegion']);

/**
 * SplitPanelDoubleImageBlock styles (CF-07 Content variant)
 *
 * Layout:
 * - Desktop Left: Primary image full bleed left, secondary with container padding right
 * - Mobile Left: Primary image full bleed right, secondary with container padding
 * - Desktop Right: Primary image full bleed right, secondary with container padding left
 * - Mobile Right: Primary image full bleed left, secondary with container padding
 */
export const splitPanelDoubleImageBlockStyles = helpers.defineMultiStyleConfig({
  baseStyle: () => ({
    container: {
      gap: {base: '48px', md: '110px'},
    },
    primaryRegion: {
      // Primary image takes more space on desktop
      flex: {base: '1', md: '1.35'},
    },
    secondaryRegion: {
      // Secondary region: row on mobile (image + text side by side), column on desktop (stacked)
      flex: {base: '1', md: '1'},
      display: 'flex',
      flexDirection: {base: 'row', md: 'column'},
      gap: {base: '16px', md: '0'},
      alignItems: {base: 'flex-start', md: 'stretch'},
      sx: {
        // Secondary image sizing
        '.component--image': {
          flex: {base: '0 0 40%', md: '1'},
          maxWidth: {base: '40%', md: '100%'},
        },
        // Rich text block styling
        '.component--rich-text-block': {
          flex: {base: '1', md: '1'},
          marginTop: {base: '0', md: '40px'},
        },
        // Title styles - 24/Body Med (desktop), 18/Body Med (mobile)
        '.component--rich-text-block h1, .component--rich-text-block h2, .component--rich-text-block h3, .component--rich-text-block h4, .component--rich-text-block h5, .component--rich-text-block h6': {
          fontSize: {base: '18px', md: '24px'},
          fontWeight: '500',
          lineHeight: {base: '160%', md: '140%'},
          color: 'brandColors.greyscale80',
        },
        // Body styles - 18/Body Reg (desktop), 16/Body Reg (mobile)
        '.component--rich-text-block .chakra-text': {
          fontSize: {base: '16px', md: '18px'},
          fontWeight: '400',
          lineHeight: '160%',
          color: 'brandColors.greyscale80',
          marginTop: {base: '8px', md: '16px'},
        },
      },
    },
  }),
  variants: {
    // Media Position: Left
    // Desktop: Primary full bleed left, secondary padding right
    // Mobile: Primary full bleed right, secondary padding left
    left: () => ({
      container: {
        flexDirection: {base: 'column', md: 'row'},
      },
      primaryRegion: {
        // Desktop: no left margin (full bleed left)
        // Mobile: no right margin (full bleed right)
        marginLeft: {base: '20px', md: '0'},
        marginRight: {base: '0', md: '0'},
      },
      secondaryRegion: {
        // Desktop: padding on right side
        // Mobile: padding on left side
        paddingLeft: {base: '20px', md: '0'},
        paddingRight: {base: '20px', md: '80px'},
      },
    }),
    // Media Position: Right
    // Desktop: Primary full bleed right, secondary padding left
    // Mobile: Primary full bleed left, secondary padding right
    right: () => ({
      container: {
        flexDirection: {base: 'column', md: 'row-reverse'},
      },
      primaryRegion: {
        // Desktop: no right margin (full bleed right)
        // Mobile: no left margin (full bleed left)
        marginLeft: {base: '0', md: '0'},
        marginRight: {base: '20px', md: '0'},
      },
      secondaryRegion: {
        // Desktop: padding on left side
        // Mobile: padding on right side
        paddingLeft: {base: '20px', md: '80px'},
        paddingRight: {base: '20px', md: '0'},
      },
    }),
  },
  defaultProps: {
    variant: 'left',
  },
});
